import * as React from "react";
import { Button, Dialog, Flex, Text, TextField } from "@radix-ui/themes";
import { Link2Icon } from "@radix-ui/react-icons";
import { useMutation } from "convex/react";
import { api } from "@repo/convex/convex/_generated/api";
import { toast } from "sonner";
import { normalizedLink } from "./items/format.ts";

interface Props {
  setIsOpen: (isOpen: boolean) => unknown;
}

export const AddItemDialog: React.FC<Props> = ({ setIsOpen }) => {
  const [url, setUrl] = React.useState<string>("");
  const [error, setError] = React.useState<string | null>(null);
  const addItem = useMutation(api.items.add);

  const save = (event: React.FormEvent) => {
    event.preventDefault();
    const link = normalizedLink(url);
    if (!link) return setError("That doesn't look like a link. Paste the whole thing.");
    setIsOpen(false);
    addItem({ url: link })
      .then(() => toast("Stashed. It'll have a title in a moment."))
      .catch((e) => {
        console.error(e);
        toast.error("Couldn't stash that one. Try again?");
      });
  };

  return (
    <Dialog.Root open={true} onOpenChange={setIsOpen}>
      <Dialog.Content maxWidth="460px" align="start" style={{ marginTop: "12vh" }}>
        <Dialog.Title>Stash a link</Dialog.Title>
        <Dialog.Description size="2" color="gray" mb="4">
          It goes to the top of the stash, here and on your phone.
        </Dialog.Description>

        <form onSubmit={save}>
          <TextField.Root
            size="3"
            value={url}
            autoFocus
            onChange={(e) => {
              setUrl(e.target.value);
              setError(null);
            }}
            placeholder="Paste a link"
            aria-label="Link"
          >
            <TextField.Slot>
              <Link2Icon />
            </TextField.Slot>
          </TextField.Root>
          {error && (
            <Text as="p" size="2" color="red" mt="2">
              {error}
            </Text>
          )}

          <Flex gap="3" mt="5" justify="end">
            <Dialog.Close>
              <Button type="button" variant="soft" color="gray">
                Cancel
              </Button>
            </Dialog.Close>
            <Button type="submit" disabled={!url.trim()}>
              Stash it
            </Button>
          </Flex>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
};
